var map = {
	"./ActivePane.svg": 20221,
	"./Attention.svg": 59437,
	"./Call.svg": 3502,
	"./Email.svg": 65153,
	"./Group 2858 (1).svg": 83985,
	"./Group 2858.svg": 60968,
	"./Id badge.svg": 72622,
	"./Linkedin.svg": 27162,
	"./Microsoft excel.svg": 45739,
	"./PatientPicture.svg": 38819,
	"./PulseOximeter.svg": 71151,
	"./SkaliLogo.png": 78075,
	"./Twitter.svg": 64092,
	"./Vector.svg": 84726,
	"./Verify (1).svg": 1785,
	"./Verify.svg": 43713,
	"./active-bell.png": 27188,
	"./add.svg": 6018,
	"./add1.svg": 58896,
	"./address.svg": 74792,
	"./admin.png": 78197,
	"./aed.png": 34161,
	"./age.png": 49691,
	"./age.svg": 45917,
	"./ai_assistant.svg": 85837,
	"./airline_seat_recline_extra.svg": 14802,
	"./airplanemode_active (1).svg": 20443,
	"./answer.png": 66181,
	"./arrow-left (2).svg": 87173,
	"./arrow-left.svg": 7485,
	"./arrow-right (1).svg": 69295,
	"./arrow-right (2).svg": 37327,
	"./arrow-right (3).svg": 64690,
	"./arrow-right (5).svg": 40632,
	"./arrow-right.svg": 86191,
	"./arrow-upper.svg": 30215,
	"./arrow_back.svg": 31935,
	"./arrow_circle_down.svg": 46494,
	"./arrow_circle_up.svg": 84647,
	"./arrow_drop_down (1).svg": 83940,
	"./arrow_drop_down.svg": 68361,
	"./assign-modal.gif": 98387,
	"./back.png": 40084,
	"./bell.png": 7232,
	"./bloodpressure.png": 10192,
	"./bp.svg": 48314,
	"./browse_activity.svg": 29219,
	"./calendar_month.svg": 17389,
	"./camera.svg": 71073,
	"./change-password.gif": 90681,
	"./chat-load-dot.svg": 30429,
	"./chatIcon.png": 25413,
	"./chatIcon.svg": 13875,
	"./close_qr.svg": 68649,
	"./close_small (1).svg": 69467,
	"./close_small (2).svg": 80540,
	"./close_small.svg": 40926,
	"./close_small_black.svg": 11457,
	"./cloud_download.svg": 27139,
	"./collapse_content.svg": 60223,
	"./collapse_content_white.svg": 87580,
	"./corporate_active.svg": 46230,
	"./corporate_fare (1).svg": 23546,
	"./crown.png": 10919,
	"./declain.png": 61200,
	"./diversion.png": 94235,
	"./diversion.svg": 44207,
	"./diversion_white_icon.svg": 80166,
	"./document_scanner.svg": 7606,
	"./double_arrow.svg": 60831,
	"./download-svgrepo-com.svg": 78077,
	"./download.svg": 98728,
	"./edit.png": 88975,
	"./edit.svg": 68044,
	"./edit_calendar.svg": 60723,
	"./edit_square.svg": 9289,
	"./ems-profile.webp": 52610,
	"./expand_content white.svg": 42260,
	"./expand_content.svg": 62268,
	"./filter_icon.svg": 99910,
	"./filter_list.svg": 20822,
	"./flight.svg": 71993,
	"./flight_land.svg": 89882,
	"./flowsheet.svg": 21064,
	"./footer-compliant-logo.png": 47130,
	"./footer-compliant-logo1.png": 75814,
	"./form(2).svg": 60982,
	"./form.svg": 9105,
	"./gender.png": 38666,
	"./gender.svg": 29142,
	"./glucometer.png": 66482,
	"./glucometer_svg_icon.svg": 18921,
	"./header-skali-logo.svg": 91139,
	"./hide.png": 59196,
	"./history-white.png": 40927,
	"./history.png": 21684,
	"./history.svg": 79326,
	"./history_active.svg": 620,
	"./home-white.png": 3288,
	"./home.png": 76553,
	"./home.svg": 72781,
	"./home_active.svg": 70218,
	"./icon-AppStore.png": 99769,
	"./icon-GooglePlay.png": 61288,
	"./iconamoon_search-light.svg": 59188,
	"./image.svg": 36945,
	"./imagesLOad.svg": 24970,
	"./inActiveFlights.svg": 69940,
	"./inactive-bell.png": 58214,
	"./knowmore.svg": 24889,
	"./left-video-call.png": 20809,
	"./loading_icon.gif": 6748,
	"./loading_icon.svg": 82349,
	"./lock.gif": 97238,
	"./log-out.png": 10929,
	"./logo.jpg": 5096,
	"./logo.png": 66949,
	"./logo.svg": 69574,
	"./mediacal-emerency.png": 52580,
	"./mediacal-emerency.svg": 56283,
	"./mediacal-emerency_active.svg": 69185,
	"./mediacal-emerency_white.png": 65498,
	"./medicalKit_Active.svg": 49746,
	"./medicalKit_InActive.svg": 59629,
	"./medical_kit.svg": 68651,
	"./medical_services.svg": 51654,
	"./move_item.png": 24020,
	"./no-activity.png": 21370,
	"./no-data.svg": 3275,
	"./no-result.png": 39092,
	"./notesEditIcon.svg": 96044,
	"./notification-message-image.png": 9419,
	"./organization.svg": 11307,
	"./phone.png": 29156,
	"./phone_hover.png": 81497,
	"./photo.svg": 84556,
	"./planeLanded.png": 11023,
	"./profile.webp": 135,
	"./pulse_alert-white.png": 54009,
	"./pulse_alert.png": 72915,
	"./pulse_alert.svg": 32431,
	"./pulse_alert_active.svg": 57018,
	"./pulseoximeter.png": 83100,
	"./qr.png": 26544,
	"./qr_code_scanner.svg": 49560,
	"./reUpload.svg": 68667,
	"./reassign.svg": 10829,
	"./report (1).svg": 37873,
	"./report-list.svg": 47780,
	"./report.svg": 95907,
	"./report_arrow_drop.png": 96372,
	"./request-notification-close.svg": 63363,
	"./requestSent.svg": 84377,
	"./rightArrow.svg": 66582,
	"./role.png": 96490,
	"./roles.svg": 35099,
	"./roles_active.svg": 80187,
	"./rotate_arrow.svg": 65899,
	"./search.svg": 51238,
	"./seat-no.svg": 24877,
	"./see_all.svg": 41265,
	"./sidebar-bg.jpg": 48604,
	"./sidebar-bg.webp": 26196,
	"./sidebar-navigation-arrow.png": 90895,
	"./skali-logo-text.svg": 72344,
	"./skallicalling.png": 54456,
	"./slider-down-aarow.png": 49551,
	"./slider-top-arrow.png": 86777,
	"./sms.svg": 69059,
	"./thermometer.png": 96374,
	"./tick-square.svg": 8161,
	"./transgender.svg": 1514,
	"./troubleshoot.svg": 14257,
	"./urban-no-data-found-3 1.png": 72200,
	"./user.png": 72315,
	"./userActivity.svg": 33116,
	"./user_activity.svg": 50622,
	"./veiw.svg": 56024,
	"./video-call-join.png": 54981,
	"./video_call_white.svg": 73744,
	"./videocam.svg": 12264,
	"./view.png": 2691,
	"./visibility.svg": 11435,
	"./visible.png": 64726,
	"./vital-upload.png": 19890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;